import Router from 'vue-router';
import router from '../../router/index';
import store from '../../store/index';
import defaultRouters from '../../router/defaultRouters';
import dynamicRouters from '../../router/dynamicRouters';
import authorityDataForPlatform from '../../utils/authorityDataForPlatform';
import authorityDataForCustomer from '../../utils/authorityDataForCustomer';
import authorityDataForPersonal from '../../utils/authorityDataForPersonal';
import { GetRoleRecord } from '@/api/role';
import generateRouters from '../../utils/generateRouters';
import generateButtons from '../../utils/generateButtons';
import { MessageBox } from 'element-ui';

const state = {
  authFromLocal: process.env.NODE_ENV === 'development' ? false : false, //权限数据来源  true-本地  false-接口
  // authFromLocal: false, //因为demo应用没有对应的接口获取权限数据，所以值固定为true 如果是新开发的应用把这行代码注释，打开上一行代码
  routes: [], //权限路由
  buttons: [], //权限按钮
  isPlatform: true //客户类型 true-平台 false-客户
};

const mutations = {
  // 设置路由值
  setRoutes: (state, routes) => {
    state.routes = routes;
  },
  // 设置按钮权限值
  setButtons: (state, buttons) => {
    state.buttons = buttons;
  },
  // 设置客户类型
  setPlatform(state, value) {
    state.isPlatform = value === 1 ? true : false;
  },
  // 重置数据
  resetState(state) {
    state.routes = [];
    state.buttons = [];
  },
  // 重置路由
  resetRouter() {
    const newRouter = new Router({
      base: process.env.BASE_URL,
      routes: defaultRouters //引入初始路由
    });
    router.matcher = newRouter.matcher;
  }
};

const actions = {
  async generateRoutes({ commit, state }) {
    if (state.authFromLocal) {
      // 本地获取路由数据及功能权限
      console.log('local');

      return new Promise(resolve => {
        commit('resetRouter');

        router.addRoute(dynamicRouters[0]);
        commit('setRoutes', dynamicRouters[0].children);
        resolve();
      });
    } else {
      console.log('online');

      let menusData = [];
      let { admin_id, customer_id, customer_type, role_id, user_id } = store.getters.userInfo;

      // 企业
      if (customer_type === 1) {
        let res = await GetRoleRecord({
          id: role_id
        });

        // 平台
        if (customer_id === 1) {
          commit('setPlatform', 1);
          // 管理员
          if (admin_id === user_id) {
            menusData = authorityDataForPlatform.menus;
          } else {
            // 管理员角色
            if (res.data.is_system === 2) {
              menusData = authorityDataForPlatform.menus;
            } else {
              // 普通用户
              menusData = res.data.menu ? JSON.parse(res.data.menu) : [];
            }
          }
        } else {
          commit('setPlatform', 2);
          // 客户
          // 管理员
          if (admin_id === user_id) {
            menusData = authorityDataForCustomer.menus;
          } else {
            // 管理员角色
            if (res.data.is_system === 2) {
              menusData = authorityDataForCustomer.menus;
            } else {
              // 普通用户
              menusData = res.data.menu ? JSON.parse(res.data.menu) : [];
            }
          }
        }
      } else {
        commit('setPlatform', 2);
        // 个人
        menusData = authorityDataForPersonal.menus;
      }

      // menusData = [];
      if (!menusData.length) {
        MessageBox.confirm('当前登录用户所属角色未授权，请联系管理员进行授权', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning'
        })
          .then(() => {
            store.commit('user/signOut');
          })
          .catch(() => {});
      }

      // 获取所有按钮权限
      const permissionButtons = await generateButtons(menusData);
      // 根据权限树生成动态菜单路由
      const dynamicRoutersData = await generateRouters(menusData);
      console.log('dynamicRoutersData--', dynamicRoutersData);
      // 添加个人中心路由
      dynamicRoutersData[0].children.push({
        path: '/personalCenter',
        name: 'personalCenter',
        hidden: true,
        component: () => import(/* webpackChunkName: "personalCenter" */ '@/views/personalCenter/index.vue'),
        meta: {
          title: '个人中心'
        }
      });

      // 添加消息通知路由-平台
      // 个人
      if (customer_type !== 1) {
        dynamicRoutersData[0].children.push({
          path: '/messageCenterForCustomer',
          name: 'messageCenterForCustomer',
          hidden: true,
          component: () =>
            import(/* webpackChunkName: "messageCenterForCustomer" */ '@/views/messageCenterForCustomer/index.vue'),
          meta: {
            title: '消息通知',
            icon: 'icon-xiaoxizhongxin'
          }
        });
      } else {
        // 平台 / 客户
        dynamicRoutersData[0].children.push({
          path: '/notice',
          name: 'notice',
          hidden: true,
          component: () => import(/* webpackChunkName: "notice" */ '@/views/messageCenter/index.vue'),
          meta: {
            title: '消息通知'
          }
        });
      }

      return new Promise(resolve => {
        commit('resetRouter');

        router.addRoute(dynamicRoutersData[0]);
        commit('setRoutes', dynamicRoutersData[0].children);
        commit('setButtons', permissionButtons);
        resolve();
      });
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
